module.exports = __webpack_public_path__ + "5627eb807ac1601cbe7787eb3f190a58.png";